import React from 'react';
import { useRecoilState } from 'recoil';
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';
import { openfoamVersionState } from 'features/optimization/state/cfdConfigAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface Props {
  label: string;
  labelXs?: number;
  fieldXs?: number;
}

export const OpenfoamVersionSelector: React.FC<Props> = ({
  label,
  labelXs = 5,
  fieldXs = 3,
}) => {
  const [cfdOpenfoamVersion, setCfdOpenfoamVersion] = useRecoilState(openfoamVersionState);

  const handleCfdOpenfoamVersionChange = (event: SelectChangeEvent<string>) => {
    setCfdOpenfoamVersion(event.target.value as string);
  };

  return (
    <Box component="div" sx={{ paddingTop: 1 }}>
      <Grid container alignItems="center" spacing={0.5}>
        <Grid item xs={labelXs}>
          <CustomTypography>
            {label}
          </CustomTypography>
        </Grid>
        <Grid item xs={fieldXs}>
          <FormControl
            size="small"
            sx={{
              minWidth: 100,
              backgroundColor: '#1e1e1e',  // Set background color here
              borderRadius: 1,  // Optional: Add a border radius for a nicer look
            }}
          >
            <InputLabel
              id="morphing-origin-select-label"
              sx={{ color: '#f0f0f0' }}
            >
              version
            </InputLabel>
            <Select
              labelId="morphing-origin-select-label"
              id="morphing-origin-select"
              value={cfdOpenfoamVersion}
              onChange={handleCfdOpenfoamVersionChange}
              label="Select Type"
              size="small"
              sx={{
                color: '#f0f0f0',  // Set input text color
                fontSize: '12px',
                '.MuiSvgIcon-root': { color: '#f0f0f0' },  // Optional: Set dropdown arrow color
              }}
            >
              <MenuItem value="v0.2.1">v0.2.1</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};
